/**
 * This file defines the list of regex that we are using in the BackOffice
 */

export const REGEX_INPUT = /^[^*?~<>[\]\\|]+$/

export const REGEX_EMAIL =
  /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const emailLength = /^\S{1,64}@\S{1,66}$/

export const usernameOrEmail =
  /((?=[A-Za-z0-9_@./#&+-\u00C0-\u017F]{5,20})[[A-Za-z0-9_@./#&+-\u00C0-\u017F]{5,20}|\S+@\S+\.\S+)$/

export const REGEX_USERNAME = /^[^~"%@&*:<>/\\{|}\s]*$/m

export const REGEX_UUID =
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/

export const REGEX_NUMBERS = /^\d+$/

export const REGEX_TEXTAREA = /^[^~<>/\\{|}]+$/

export const REGEX_NUMBER_FLOAT = /^([0-9]*[.])?[0-9]+$/

export const REGEX_CONSECUTIVE_WHITESPACE = /\s\s/

export const REGEX_NO_NUMBERS_NOR_LETTERS = /[^a-zA-Z0-9]/g

export const REGEX_CURRENCY = /(\d)(?=(\d{3})+(?!\d))/g

export const PASSWORD_VALIDATORS = [
  {
    regExp: /[a-z]/,
    error: 'The password should have at least 1 lowercase letter.',
  },
  {
    regExp: /\d/,
    error: 'The password should have at least 1 number.',
  },
  {
    regExp: /[A-Z]/,
    error: 'The password should have at least 1 uppercase letter.',
  },
  {
    regExp: /[!@#$%^&*?¿¡,:;{}|'"`~)(+=._-]/,
    error: 'The password should have at least 1 special character. ',
  },
  {
    regExp: /^.{9,20}$/,
    error: 'The password should be between 9 and 20 characters long.',
  },
]
